var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_61",
    "data-name": "Group 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.55,
    height: 47.55,
    viewBox: "0 0 47.55 47.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -0.003,
    x2: 0.5,
    y2: 0.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 56.863,
    y1: -11.079,
    x2: 56.863,
    y2: -10.185,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb92e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#dda228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#aa7c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#7c5b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#563f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#36280a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1e1605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#0d0902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#030200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 1.02,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#442914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#3d230f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#2a1301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    xlinkHref: "#radial-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M-2022.189,350.081a23.776,23.776,0,0,1-23.777,23.775,23.774,23.774,0,0,1-23.772-23.775,23.774,23.774,0,0,1,23.772-23.775A23.776,23.776,0,0,1-2022.189,350.081Z",
    transform: "translate(2069.738 -326.306)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M-2014.148,340.121c0,5.96-7.1,10.792-15.862,10.792s-15.86-4.832-15.86-10.792,7.1-10.791,15.86-10.791S-2014.148,334.161-2014.148,340.121Z",
    transform: "translate(2053.783 -328.328)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M-2050.023,404.523c0-6.935,7.719-12.557,17.237-12.557s17.238,5.622,17.238,12.557-7.718,12.556-17.238,12.556S-2050.023,411.457-2050.023,404.523Z",
    transform: "translate(2056.558 -370.198)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(10.53 15.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(0 10.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M-2037.055,413.716a.918.918,0,0,1-.381-.083.921.921,0,0,1-.457-1.219,14.493,14.493,0,0,1,13.16-8.489,14.5,14.5,0,0,1,13.162,8.489.921.921,0,0,1-.457,1.219.92.92,0,0,1-1.219-.457,12.651,12.651,0,0,0-11.486-7.41,12.648,12.648,0,0,0-11.483,7.41A.92.92,0,0,1-2037.055,413.716Z",
    transform: "translate(2037.975 -403.925)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(3.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M-2022.855,375.8a2.376,2.376,0,0,1-2.376,2.378,2.379,2.379,0,0,1-2.378-2.378,2.379,2.379,0,0,1,2.378-2.377A2.376,2.376,0,0,1-2022.855,375.8Z",
    transform: "translate(2027.609 -373.424)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M-1978.029,375.8a2.379,2.379,0,0,1-2.379,2.378,2.377,2.377,0,0,1-2.376-2.378,2.376,2.376,0,0,1,2.376-2.377A2.378,2.378,0,0,1-1978.029,375.8Z",
    transform: "translate(1997.644 -373.424)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.97ebf777fedb10b8d430c6dda5526f63.svg";
export { ForwardRef as ReactComponent };